import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import BigNumber from "bignumber.js";
import { DiscountTypes } from "src/api/booksOrder";
export const CheckoutLayoutStyle = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ _jsx("article", {
        className: cn("flex w-full max-w-[1200px] h-full justify-center gap-10  min-h-[calc(100vh-463px)] py-10", className),
        children: children
    });
};
export const BoxContainerStyle = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn("container flex max-lg:flex-col max-lg:mx-6 max-sm:m-0", className),
        children: children
    });
};
export const RadiusBoxStyle = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn("flex flex-col gap-6 p-6 bg-white rounded-lg border border-gray-100", "max-sm:rounded-none max-sm:border-none max-sm:px-5 max-sm:py-6", className),
        children: children
    });
};
export const RadiusBoxLargeStyle = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn("flex flex-col gap-6 p-6 bg-white rounded-lg shadow-sm", "max-sm:px-5 max-sm:py-6", className),
        children: children
    });
};
//할인액 계산
export const calculateDiscountAmount = (param)=>{
    let { price , discountType , discountValue , discountMaximumPrice  } = param;
    try {
        let discountAmount = new BigNumber(0);
        const safePrice = new BigNumber(price || 0);
        const safeDiscountValue = new BigNumber(discountValue || 0);
        const safeDiscountMaximumPrice = new BigNumber(discountMaximumPrice || 0);
        // 가격이 0 이하이면 할인 없음
        if (safePrice.isLessThanOrEqualTo(0)) {
            return "0";
        }
        switch(discountType){
            case DiscountTypes.AMOUNT:
                discountAmount = safeDiscountValue;
                break;
            case DiscountTypes.PERCENT:
                //할인금액을 10의 단위에서 내림
                const discounted = safePrice.multipliedBy(safeDiscountValue).dividedBy(1000).integerValue(BigNumber.ROUND_FLOOR).multipliedBy(10);
                discountAmount = safeDiscountMaximumPrice.isGreaterThan(discounted) ? discounted : safeDiscountMaximumPrice;
                break;
            default:
                discountAmount = safePrice;
        }
        // 할인금액이 가격을 초과하지 않도록 제한
        const finalDiscount = discountAmount.isGreaterThan(safePrice) ? safePrice : discountAmount;
        return finalDiscount.toString();
    } catch (error) {
        ;
        return "0";
    }
};
//할인된 차액계산
export const calculateDiscountedAmount = (param)=>{
    let { price , discount  } = param;
    return new BigNumber(price).minus(discount).toString();
};
export const calculatePayAmount = (orderItems)=>{
    //진짜 가격 (누적합)
    const total = orderItems.reduce((acc, item)=>{
        return acc.plus(new BigNumber(item.price));
    }, new BigNumber(0));
    //총결제금액 (할인된 금액의 누적합)
    const discountedTotal = orderItems.reduce((acc, item)=>{
        return acc.plus(new BigNumber(item.discountedPrice));
    }, new BigNumber(0));
    //총 쿠폰으로 할인된 금액 (진짜가격 - 총결제금액)
    const discountedAmount = orderItems.reduce((acc, item)=>{
        return acc.plus(new BigNumber(item.price).minus(new BigNumber(item.discountedPrice)));
    }, new BigNumber(0));
    return {
        total: total.toNumber(),
        discountedAmount: discountedAmount.toNumber(),
        discountedTotal: discountedTotal.toNumber()
    };
};
